import { render } from "./TransferBankAccountFormContainer.vue?vue&type=template&id=0d68344f"
import script from "./TransferBankAccountFormContainer.vue?vue&type=script&lang=js"
export * from "./TransferBankAccountFormContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__